const ACTION = {
    UPDATE_USED_PHONE: 'UPDATE_USED_PHONE',
    UPDATE_USED_PHONE_ERROR_TEXT: 'UPDATE_USED_PHONE_ERROR_TEXT',
    UPDATE_USED_PHONE_ERROR_TEXT_BY_INDEX: "UPDATE_USED_PHONE_ERROR_TEXT_BY_INDEX"
}

export default ACTION;